import React from "react";
import FaIcon from "./FaIcon";

export default () => (
  <>
    &nbsp;
    <FaIcon name="angle-right" />
  </>
);
